import { z } from "zod";

export const EmblemRaritySchema = z.enum([
	"Special",
	"Common",
	"Rare",
	"Majestic",
	"Legendary",
	"Fabled"
]);

export type EmblemRarity = z.infer<typeof EmblemRaritySchema>;
